module.exports = __webpack_public_path__ + "static/media/save-svgrepo-com (3).d4a119f8.svg";